import React from "react";
import { Box, Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Card = styled(Box)(({
  theme
}) => ({
  width: 320,
  borderRadius: 4,
  padding: theme.spacing(3),
  border: "2px solid",
  borderColor: theme.palette.divider,
  boxShadow: theme.shadows[2],
  [theme.breakpoints.down("sm")]: {
    width: 300
  },
  "@media (max-width: 375px)": {
    width: 280
  }
}));
export default function RegulationCardSkeleton() {
  return /*#__PURE__*/_jsxs(Card, {
    children: [/*#__PURE__*/_jsx(Skeleton, {
      variant: "text",
      width: "80%",
      height: 28
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "text",
      width: "50%",
      height: 20,
      sx: {
        mb: 1
      }
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "text",
      width: "100%"
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "text",
      width: "90%"
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "text",
      width: "60%"
    }), /*#__PURE__*/_jsx(Box, {
      display: "flex",
      gap: 0.75,
      mt: 1.5,
      children: [70, 90, 60].map((w, i) => /*#__PURE__*/_jsx(Skeleton, {
        variant: "rounded",
        width: w,
        height: 22,
        sx: {
          borderRadius: 999
        }
      }, i))
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "text",
      width: "40%",
      height: 16,
      sx: {
        mt: 2
      }
    })]
  });
}